export const MouseButton = {
  Left: 1,
  Right: 2,
  Middle: 4,
}
